export default {
  id: 'l-6',
  navTitleID: 'l-6.navTitle',
  pages: [
    {
      id: 'page-1',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textID: 'text',
          styling: {
            textAlign: 'center'
          }
        }
      ]
    },
    {
      id: 'page-2',
      components: [
        {
          type: 'video',
          videoSrc: 'KN_08'
        }
      ]
    },
    {
      id: 'page-3',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textLayout: 'inverse',
          textID: 'text'
        }
      ]
    },
    {
      id: 'page-4',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textID: 'text'
        }
      ]
    },
    {
      id: 'page-5',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textID: 'text'
        },
        {
          type: 'carousel',
          slides: [
            {
              type: 'text',
              titleID: 'title1',
              textID: 'text1'
            }, {
              type: 'text',
              titleID: 'title2',
              textID: 'text2'
            },
            {
              type: 'text',
              titleID: 'title3',
              textID: 'text3'
            }
          ]
        }
      ]
    },
    {
      id: 'page-6',
      components: [
        {
          type: 'mc-standard',
          questionID: 'question',
          instructionID: 'instruction',
          hintID: 'hint',
          options: [
            {
              isCorrect: false,
              textID: 'option-1',
              feedbackTextID: 'option-1-feedback'
            },
            {
              isCorrect: true,
              textID: 'option-2',
              feedbackTextID: 'option-2-feedback'
            },
            {
              isCorrect: false,
              textID: 'option-3',
              feedbackTextID: 'option-3-feedback'
            }
          ]
        }
      ]
    },
    {
      id: 'page-7',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textID: 'text',
          styling: {
            textAlign: 'center'
          }
        },
        {
          type: 'carousel',
          slides: [
            {
              type: 'text',
              titleID: 'title1',
              textID: 'text1'
            }, {
              type: 'text',
              titleID: 'title2',
              textID: 'text2'
            },
            {
              type: 'text',
              titleID: 'title3',
              textID: 'text3'
            }
          ]
        }
      ]
    },
    {
      id: 'page-8',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textID: 'text',
          styling: {
            textAlign: 'center'
          }
        },
        {
          type: 'carousel',
          slides: [
            {
              type: 'text',
              titleID: 'empty',
              textID: 'text1'
            }, {
              type: 'text',
              titleID: 'empty',
              textID: 'text2'
            },
            {
              type: 'text',
              titleID: 'empty',
              textID: 'text3'
            }
          ]
        }
      ]
    },
    {
      id: 'page-9',
      components: [
        {
          type: 'image',
          src: '/deltakere/mariasmiler.png',
          alt: 'Bilde av Maria',
          width: '20rem',
          height: 'auto'
        },
        {
          type: 'mc-standard',
          textID: 'text',
          questionID: 'question',
          instructionID: 'instruction',
          hintID: 'hint',
          rightFeedbackID: 'feedback-right',
          wrongFeedbackID: 'feedback-wrong',
          options: [{
            textID: 'option-1',
            isCorrect: true
          },
          {
            textID: 'option-2',
            isCorrect: false
          },
          {
            textID: 'option-3',
            isCorrect: false
          },
          {
            textID: 'option-4',
            isCorrect: true
          },
          {
            textID: 'option-5',
            isCorrect: true
          }
          ]
        }
      ]
    }
  ]
}
